import React from 'react';

const SearchBox = ({ searchChange }) => {
  return (
    <div className="w-full max-w-md relative">
      <form className="flex items-center border border-green-800 rounded bg-white p-1">
        {/* Search Icon */}
        <span
          className="text-green-800 text-lg mr-2 ml-1 flex items-center bx bx-search"
          aria-hidden="true"
        />
        {/* Input Field */}
        <input
          onChange={searchChange}
          type="search"
          placeholder="Enter Text To Search"
          className="bg-white border-none text-sm w-full h-4 focus:outline-none"
        />
      </form>
    </div>
  );
};

export default SearchBox;